import React from "react"
import { passwordRules } from "helpers/password_policy_helpers"

// BDSJEA-230: feedback en tiempo real de la politica de clave mientras el
// usuario tipea "Clave nueva". Reutiliza el mismo array de reglas que arma
// el validationSchema de Yup (helpers/password_policy_helpers.js) para que
// el checklist visual y lo que efectivamente bloquea el submit nunca queden
// desincronizados.
const PasswordPolicyChecklist = ({ value, context }) => (
  <ul className="list-unstyled mb-3 font-size-13" aria-live="polite">
    {passwordRules.map(rule => {
      const cumple = rule.check(value || "", context)
      return (
        <li key={rule.id} className={cumple ? "text-success" : "text-danger"}>
          <i
            className={`bx ${
              cumple ? "bx-check-circle" : "bx-x-circle"
            } align-middle me-1`}
          />
          {rule.label}
        </li>
      )
    })}
  </ul>
)

export default PasswordPolicyChecklist
